module.exports = __webpack_public_path__ + "static/media/Sq2.518c09aa.svg";